import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  clearResumeStep,
  finalSteps,
  getStepFromPath,
  isTrackableStep,
  saveResumeStep
} from "../../utils/resumeStep";

// Ghi lại step user đang đứng để lần sau quay lại còn hỏi "tiếp tục?"
export const StepTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const step = getStepFromPath(pathname);

    if (isTrackableStep(step)) {
      saveResumeStep(step);
    } else if (finalSteps.includes(step)) {
      clearResumeStep();
    }
  }, [pathname]);

  return null;
};

export default StepTracker;
